import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import seo_img from '../img/seo/seo-1.svg'
import seo_img_2 from '../img/seo/seo-2.svg'

import register_now from '../img/register-now-left.svg'

import ogp_cover from '../img/cover.png'

export default class Seo extends React.Component {

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
	    var mask = document.getElementById('mask');
	    mask.addEventListener('touchstart', this.pageClick, false);
	}

	render() {
		return (
			<div>

				<Helmet
					title="Work from Home - UvoCorp.com"
					meta={[
						{ name: "description", content: "Work from home, writing jobs from home. Start earning money from writing. Apply for a job online with UvoCorp.com. Registration is free." },

						{ property: 'og:title', content: "Work from Home - UvoCorp.com" },
						{ property: 'og:description', content: "Work from home, writing jobs from home. Start earning money from writing. Apply for a job online with UvoCorp.com. Registration is free." },
						{ property: 'og:site_name', content: "UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/work_from_home_online.html" }
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>

				<div className="wrapper">
				
					<div className="inner-header">
						<div className="container">
							<h1>The Chance to Work from Home</h1>
							<Link to="/register_email.html">Register now</Link>
						</div>
					</div>

					<div className="home-benefits home-block hiring-benefits">
						<div className="container">
							<h1>The benefits you enjoy working as a freelance writer:</h1>
							<ul className="home-benefits-list">
								<li className="home-benefits-1">
									<p>No registration fees</p>
								</li>
								<li className="home-benefits-2">
									<p>High wages</p>
								</li>
								<li className="home-benefits-3">
									<p>Working from home</p>
								</li>
								<li className="home-benefits-4">
									<p>Orders in the sphere <br />of your interest</p>
								</li>
								<li className="home-benefits-5">
									<p>24/7 available <br />support team</p>
								</li>
								<li className="home-benefits-6">
									<p>Payments always <br />on time</p>
								</li>
								<li className="home-benefits-7">
									<p>Manage your time <br />and workload yourself</p>
								</li>
							</ul>
						</div>
					</div>

					<div className="home-pricing-info">
						<div className="container">
							<p>There is no other company that offers <strong>$15</strong>/page written by an <span className="home-pricing-info-role">ESL</span> writer and <strong>$26</strong>/page completed by an <span className="home-pricing-info-role">ENL</span> writer.</p>
							<Link to="/prices.html">View Pricing <svg id="arrow-right" width="22" height="22"><path fill="#black" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></Link>
						</div>
					</div>

					<div className="inner-white hiring seo">
						<div className="container">
							<h2>Writers wanted</h2>
							<div className="row">
								<div className="col-md-9">
									<p>Dear potential <Link to="/">UVOCORP</Link> writers, we are currently hiring:</p>
									<ol className="hiring-steps">
										<li>Writers who are Native Speakers of English (these writers have exclusive access to orders which need to be written by a Native Speaker of English);</li>
										<li>English as a Second Language writers with a profound knowledge in Humanities, Business Studies, Applied, and Social Sciences;</li>
										<li>Writers with a profound knowledge in the following disciplines. Working only on them on a permanent basis is our internal separate project:</li>
									</ol>
								
									<ul className="hiring-disciplines">
										<li className="discipline_8">Accounting</li>
										<li className="discipline_15">Architecture, Building and Planning</li>
										<li className="discipline_14">Biology (and other Life Sciences)</li>
										<li className="discipline_13">Chemistry</li>
										<li className="discipline_1">Engneering</li>
										<li className="discipline_10">Civil Engineering</li>
										<li className="discipline_7">Computer Science</li>
										<li className="discipline_5">IT, Web</li>
										<li className="discipline_3">Finance</li>
										<li className="discipline_11">Mathematics</li>
										<li className="discipline_12">Physics</li>
										<li className="discipline_4">Statistics</li>
									</ul>
								</div>
								<div className="hiring-img">
									<img src={seo_img_2} alt="Seo Image"/>
								</div>
							</div>

							<div className="row seo-row">

								<div className="col-md-4 seo-img-container">
									<div className="seo-img">
										<img src={seo_img} alt="Seo Image"/>
									</div>
								</div>
								<div className="col-md-8">

									<p>Today’s job market is flooded with degreed and skilled individuals looking for employment opportunities. However, for a variety of reasons, jobs are scarce, competition is stiff, and sometimes pay is lower than desired. As a result, individuals have increasingly turned to prospects for working at home to augment their income. The concept of working a job from home is steadily increasing with popularity, thanks largely to the Internet; however, many online jobs are not as they appear to be. Often they are scams designed to take your money through false guarantees that involve an upfront monetary investment from you. You need to avoid such cons and discover a position that offers you a real opportunity to earn money in exchange for your talents and hard work while working at home. Advertisements for work-at-home job opportunities permeate the web; however, with us you will find more than just a website. You will find a solution to your financial needs through freelancing opportunities. We are in need of high quality writers interested in our “work from home” offer.</p>
									<p>Many writers and other artists explore opportunities to earn money by working at home, whether part-time or full-time. The number of individuals seeking such opportunities online is steadily increasing. You can be one of those individuals by writing from the comfort of your own home. Get comfortable. Enjoy earning money while sitting in front of a fireplace on a cold afternoon or viewing the scenery from your desk situated in front of a window. If you are willing to work as a freelance writer from the comforts of your own home and are willing to access our considerable client base, then we have a position to offer you. Our clients desire access to highly capable and considerate writers who can provide assistance to them in completing projects and various writing assignments. Furthermore, our clients are in need of guidance; they require someone to model for them the solid writing skills they wish to develop for themselves.</p>
									<p>Sometimes, the connotation one associates with work from home jobs is low-paid SEO content writing orders that involve composing a number of pages for only a few dollars in compensation. However, at UVOCorp, your time and effort are worth more than a mere penny a word. You are valued for your level of expertise and writing skills, and compensated accordingly. As a result, you are able to earn money from home to satisfy your financial needs. Our freelance writing positions are created for the purpose of bringing together skilled writers and clients in need of writing assistance. Our freelance writer positions are designed for highly skilled writers with advanced college degrees who are consistently willing and able to provide quality writing to our clients.</p>
									<p>Our goals including offering freelance writing positions for those who wish to work from home as well as affording to those writers flexibility in both scheduling and in kinds of writing opportunities available for selection. In addition, we endeavor to provide financial security to our freelance writers. To become successful in work-at-home job positions, be aware that you should never be asked or required to pay anyone to acquire information about the job to which you intend to apply or fill. Many work-at-home online jobs exist, so be careful not to throw money away on a scam. We offer you a chance to utilize your writing expertise and knowledge of subject matter, along with experiences to earn money while working from home.</p>
									<p>Do you fantasize about the convenience of working comfortably from home? Turn that fantasy into reality by applying to be a writer with us as <Link to="/">UVOCorp</Link>. Join our team composed of other dedicated writers, our conscientious support team, and our meticulous management staff in endeavoring to create the best online writing jobs available. Our objective is to be your answer to earning money through offering your writing skills where you can come to understand that you can have a positive impact. When you have a paid online writing job, you are able to establish your own routine, work from anywhere, including the comfort of your home, while also meeting other needs such as family obligations. We endeavor to provide you with a work-at-home solution that meets your personal goals, including an individualized schedule and your desired lifestyle. Having a position that allows you the flexibility to work from anywhere you wish adds immeasurably to the quality and overall enjoyment of your life.</p>

								</div>
							</div>
						</div>
					</div>

					<div className="inner-registration inner-registration-left">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<Link to="/register_email.html">Start registration</Link>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/work_from_home_online.html.js